module.exports = __webpack_public_path__ + "static/img/product_dianhanHistory.ae30b2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_dianhanHistory.jpg
// module id = 9rLh
// module chunks = 0